import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  loadFilterTemplateListSuccessful, loadFilterTemplateListFailed, loadFilterTemplateListBegin,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL_V2, DEFAULT_ITEMS_OF_PAGE, LOADING_DELAY } from '../../../configs';
import { addFilterQuery } from '../../../utils/addFilterQueryWithCondition';

export default function* loadFilterTemplateList(action) {
  try {
    const { payload = {} } = action;
    const {
      limit = DEFAULT_ITEMS_OF_PAGE,
      page = 1,
      filter,
      sort,
    } = payload;
    let pool = {
      limit,
      page,
    };
    if (typeof filter === 'object' && Object.keys(filter).length) {
      yield delay(LOADING_DELAY);
      pool.filter = addFilterQuery(filter);
    }
    if (typeof sort === 'string' && sort.length) {
      pool = { ...pool, sort };
    }
    yield put(loadFilterTemplateListBegin());
    const url = `${BACKEND_URL_V2}/filter-templates/search`;
    // const url = `${BACKEND_URL_V2}/filter-templates`;

    const dataResponse = yield makeRequest(url, pool, action, 'POST', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadFilterTemplateListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadFilterTemplateListFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadFilterTemplateListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
